export const Logo = ({ variant = "light", size = "md" }) => {
  const color = variant === "light" ? "#FFFFFF" : "#0B192C";
  const sizes = { sm: "text-lg", md: "text-2xl", lg: "text-3xl" };
  return (
    <div
      data-testid="brand-logo"
      className={`font-display font-light ${sizes[size]}`}
      style={{ color, letterSpacing: "0.24em" }}
    >
      SUITE<span style={{ fontWeight: 500 }}>CROWD</span>
    </div>
  );
};
